<template>
  <v-dialog v-model="dialog" :retain-focus="false" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="rankResultsForm" v-model="isFormValid">
            <v-layout wrap>
              <v-flex xs12>
                <AthletesDropdown
                  @parentValueChange="editedItem.athleteId = $event"
                  :parentValue="editedItem.athleteId"
                />
                {{ editedItem.athleteId }}
              </v-flex>
              <v-flex xs12 sm6>
                <MeetDropdown
                  @change-meet="editedItem.meetId = $event"
                  :resultsBased="true"
                ></MeetDropdown>
              </v-flex>
              <v-flex xs12 sm6>
                <catValueDropDown
                  :outlined="true"
                  :catName="'SWIMMING_FACILITY'"
                  v-model.trim="editedItem.facilityType"
                  label="Facility Type"
                  v-on:parentValListChange="onChangeFacility"
                />
              </v-flex>
              <!--Multiple Fields-->
              <v-layout
                wrap
                v-for="(result, index) in editedItem.results"
                :key="index"
              >
                <v-flex xs12>Result {{ index + 1 }}</v-flex>
                <v-flex xs12 sm6>
                  <v-menu
                    v-model="result.menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="result.resultDate"
                        label="Result Date"
                        :rules="requiredRule"
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="event"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="result.resultDate"
                      @input="result.menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6>
                  <EventDropdown
                    @parentValueChange="result.setLibSetId = $event"
                    :parentValue="result.setLibSetId"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    hide-details
                    :rules="[requiredRule, timeFormatRule]"
                    v-model="result.resultTime"
                    label="Result Time (HH:mm:ss.SSS)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    type="number"
                    :rules="requiredRule"
                    v-model="result.place"
                    label="Place"
                    prepend-inner-icon="stairs"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    outlined
                    v-model="result.comments"
                    label="Comment"
                    hide-details
                    :rules="requiredRule"
                    prepend-inner-icon="comment"
                    @change="changeComment"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-checkbox
                    color="primary"
                    label="IsOfficial"
                    :value="result.isOfficial"
                    v-model="result.isOfficial"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-btn
                    v-if="index <= 8"
                    color="secondary"
                    text
                    @click="addResultOption"
                    >+ Add Result</v-btn
                  >
                </v-flex>
                <v-flex xs12 sm6>
                  <v-btn
                    v-if="index > 0"
                    color="secondary"
                    text
                    @click="removeResultOption(index)"
                    >- Remove Result</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">Cancel</v-btn>
        <v-btn
          :disabled="!isFormValid"
          color="secondary"
          text
          @click="actionName"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validation } from "@/mixins/validationMixin";
import AthletesDropdown from "@/components/shared/athletes_dropdown.vue";
import EventDropdown from "@/components/shared/event_dropdown.vue";
import MeetDropdown from "@/components/shared/meet_dropdown.vue";
import catValueDropDown from "@/components/shared/cat_val_dropdown.vue";

export default {
  name: "rankResultsForm",
  components: {
    AthletesDropdown,
    EventDropdown,
    MeetDropdown,
    catValueDropDown,
  },
  mixins: [validation],
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    index: {
      type: [Number, Boolean, String],
      default: () => -1,
      required: true,
    },
  },
  data() {
    return {
      isFormValid: true,
      menu: false,
      result: {
        resultId: null, // (multiple)
        setLibSetId: "", // Event Id (multiple)
        resultTime: "00:00:00.000", // Result Time (multiple)
        resultDate: new Date().toISOString().substring(0, 10), // Result Date (multiple)
        comments: "", // Comments (multiple)
        isOfficial: true, // Check (multiple)
        place: "", // Place (multiple)
        menu: false,
      },
      requiredRule: (v) => !!v || "This field is required.",
      timeFormatRule: (v) =>
        /^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])(\.\d{1,3})?$/.test(
          v
        ) || "Time must be in HH:mm:ss.SSS format.",
      editedItem: {
        athleteId: "", // Select Athlete id by name (single)
        setId: 1, // (single)
        pulse: 1, // (single)
        facilityType: "25m", // Facility Type (single)
        meetId: "", // Meet Name by id (single)
        points: "", // (single)
        updateSource: "test", // single
        results: [
          {
            resultId: null, // (multiple)
            setLibSetId: "", // Event Id (multiple)
            resultTime: "00:00:00.000", // Result Time (multiple)
            resultDate: new Date().toISOString().substring(0, 10), // Result Date (multiple)
            comments: "", // Comments (multiple)
            isOfficial: true, // Check (multiple)
            place: "", // Place (multiple)
            menu: false,
          },
        ],
      },
      // TODO Take out this to table data constants
      defaultItem: {
        athleteId: "", // Select Athlete id by name (single)
        pulse: "", // (single)
        facilityType: "", // Facility Type (single)
        meetId: 1, // Meet Name by id (single)
        points: "", // (single)
        updateSource: "test", // (single)
        results: [
          {
            resultId: null, // (multiple)
            setLibSetId: 1, // Event id (multiple)
            setId: 1, // (single)
            resultTime: "", // Result Time (multiple)
            resultDate: new Date().toISOString().substring(0, 10), // Result Date (multiple)
            comments: "", // Comments (multiple)
            isOfficial: null, // Check (multiple)
          },
        ],
      },
      // TODO Take out this to validation mixin
      // durationTimeRules: [
      //   (v) =>
      //     // with hours-          /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)?(?:[.][0-9]{3})?$/.test(
      //     /^(?:([0-5]?\d):)?([0-5]?\d)?(?:[.][0-9]{3})?$/.test(v) ||
      //     "Result must be in hh:mm:ss.mil format",
      // ],
    };
  },
  computed: {
    formTitle() {
      return this.index > 0 ? "Edit result" : "New result";
    },
    actionName() {
      return this.index > 0 ? this.editResult : this.addResult;
    },
  },
  methods: {
    validateForm() {
      this.$refs.rankResultsForm.validate();
    },
    editResult() {},
    addResult() {
      console.log(this.editedItem);
     // this.$emit("set-loading", true);
      if (this.isFormValid) {
        let single = {
          athleteId: +this.editedItem.athleteId,
          pulse: +this.editedItem.pulse,
          facilityType: this.editedItem.facilityType,
          meetId: +this.editedItem.meetId,
          points: this.editedItem.points,
          updateSource: this.editedItem.updateSource,
          clubId: this.$route.params.club ? this.$route.params.club : 1,
        };
        const promises = this.editedItem.results.map((result) => {
          this.$store
            .dispatch("resultMerge", {
              ...single,
              clubId: this.$route.params.club ? this.$route.params.club : 1,
              resultId: result.resultId, // (multiple)
              setLibSetId: +result.setLibSetId, // Event id (multiple)
              setId: result.setId, // (single)
              resultTime: result.resultTime, // Result Time (multiple)
              resultDate: result.resultDate, // Result Date (multiple)
              comments: result.comments, // Comments (multiple)
              isOfficial: result.isOfficial ? 1 : 0, // Check (multiple)
              place: +result.place,
            })
            .then(() => {
              this.$toast.success("New result has been added");
            })
            .catch((error) => {
              console.error(error);
            });
        });
        Promise.all(promises).then(() => {
          //this.$emit("set-loading", false);
         // this.close();
        });
      } else {
        //this.$emit("set-loading", false);
        this.validateForm();
      }
    },
    close() {
      this.$emit("close-form");
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    changeComment() {
      console.log("Comments");
      console.log(this.editedItem);
      console.log(this.defaultItem);
    },
    addResultOption() {
      this.editedItem.results.push({
        resultId: null, // (multiple)
        setLibSetId: "", // Event Id (multiple)
        resultTime: "00:00:00.000", // Result Time (multiple)
        resultDate: new Date().toISOString().substring(0, 10), // Result Date (multiple)
        comments: "", // Comments (multiple)
        isOfficial: true, // Check (multiple)
        place: "", // Place (multiple)
      });
    },
    removeResultOption(index) {
      if (index > -1) {
        this.editedItem.results.splice(index, 1);
      }
      return this.editedItem;
    },
    // editCategory() {},
    // addCategory() {
    //   this.$emit("set-loading", true);
    //   this.$store
    //     .dispatch("categoryMerge", this.catData)
    //     .then(() => {
    //       this.$emit("set-loading", false);
    //       this.$toast.success(
    //         `Category ${this.catData.catName} has been added`
    //       );
    //       this.close();
    //     })
    //     .catch(error => {
    //       console.error(error);
    //       this.$emit("set-loading", false);
    //       this.close();
    //     });
    // }
  },
};
</script>
